import { useEffect, useMemo, useRef } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import * as THREE from "three";
import { SkeletonUtils } from "three-stdlib";

export default function Tacos({
  position = [-32.81, -0.07, 8.1],
  rotation = [0, 0, 0],
  scale = 1,
  ...rigidBodyProps
}) {
  const group = useRef(null);
  const { scene, animations } = useGLTF("/tacos.glb");
  const tacosScene = useMemo(() => SkeletonUtils.clone(scene), [scene]);
  const { actions } = useAnimations(animations, group);

  useEffect(() => {
    tacosScene.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  }, [tacosScene]);

  useEffect(() => {
    if (!actions) return undefined;

    const actionNames = Object.keys(actions);
    const defaultActionName = actionNames[0];
    if (!defaultActionName) return undefined;

    const defaultAction = actions[defaultActionName];
    if (!defaultAction) return undefined;

    defaultAction.reset().setLoop(THREE.LoopRepeat, Infinity).fadeIn(0.2).play();

    return () => {
      defaultAction.stop();
    };
  }, [actions]);

  return (
    <RigidBody
      type="fixed"
      colliders="trimesh"
      position={position}
      rotation={rotation}
      {...rigidBodyProps}
    >
      <group ref={group} scale={scale}>
        <primitive object={tacosScene} />
      </group>
    </RigidBody>
  );
}

useGLTF.preload("/tacos.glb");
